// Copyright (C) 2017-2023 Smart code 203358507

const React = require('react');
const { useModelState } = require('stremio/common');
const { useCore } = require('stremio/core');
const { useRouteActive } = require('stremio/common/useRouteFocused');
const { filterAddonResources } = require('../../caroline/addons/portugueseStreams');

const map = (metaDetails) => ({
    ...metaDetails,
    streams: filterAddonResources(metaDetails.streams),
    metaItem: metaDetails.metaItem !== null && metaDetails.metaItem.content.type === 'Ready' ?
        {
            ...metaDetails.metaItem,
            content: {
                ...metaDetails.metaItem.content,
                content: {
                    ...metaDetails.metaItem.content.content,
                    released: new Date(
                        typeof metaDetails.metaItem.content.content.released === 'string' ?
                            metaDetails.metaItem.content.content.released
                            :
                            NaN
                    ),
                    videos: metaDetails.metaItem.content.content.videos.map((video) => ({
                        ...video,
                        released: new Date(
                            typeof video.released === 'string' ?
                                video.released
                                :
                                NaN
                        ),
                    }))
                }
            }
        }
        :
        metaDetails.metaItem
});

const useMetaDetails = (urlParams) => {
    const core = useCore();
    const routeActive = useRouteActive();
    const previouslyActive = React.useRef(routeActive);
    const activeAction = React.useRef(null);
    const reloadPending = React.useRef(false);
    const action = React.useMemo(() => {
        if (typeof urlParams.type === 'string' && typeof urlParams.id === 'string') {
            return {
                action: 'Load',
                args: {
                    model: 'MetaDetails',
                    args: {
                        metaPath: {
                            resource: 'meta',
                            type: urlParams.type,
                            id: urlParams.id,
                            extra: []
                        },
                        streamPath: typeof urlParams.videoId === 'string' && urlParams.videoId !== '' ?
                            {
                                resource: 'stream',
                                type: urlParams.type,
                                id: urlParams.videoId,
                                extra: []
                            }
                            :
                            null,
                        guessStream: true,
                    }
                }
            };
        } else {
            return {
                action: 'Unload'
            };
        }
    }, [urlParams]);
    activeAction.current = routeActive ? action : null;
    React.useEffect(() => {
        activeAction.current = routeActive ? action : null;
        return () => { activeAction.current = null; };
    }, [routeActive, action]);
    const state = useModelState({ model: 'meta_details', action, map });
    React.useEffect(() => {
        // This route is retained underneath Player. Trailer/source resolution
        // owns the shared model temporarily and unloads it when returning.
        if (routeActive && !previouslyActive.current) core.transport.dispatch(action, 'meta_details');
        previouslyActive.current = routeActive;
    }, [routeActive, action, core.transport]);
    const reload = React.useCallback(async () => {
        const selectedAction = activeAction.current;
        if (reloadPending.current || !selectedAction || selectedAction.action !== 'Load') return;
        reloadPending.current = true;
        try {
            await core.transport.dispatch({ action: 'Unload' }, 'meta_details');
            if (activeAction.current === selectedAction) await core.transport.dispatch(selectedAction, 'meta_details');
        } finally {
            reloadPending.current = false;
        }
    }, [core.transport]);
    return { ...state, reload };
};

module.exports = useMetaDetails;
